import { useEffect, useMemo } from 'react';
import _debounce from 'lodash/debounce';

const useInfiniteScroll = onScrollToBottom => {
  const scrollCallback = useMemo(
    () =>
      _debounce(
        e => {
          if (!e) return;
          if (e.clientHeight < 0) return;

          const { scrollHeight, clientHeight, scrollTop } = document.documentElement;
          const isNearBottom = scrollHeight <= scrollTop + clientHeight + 200;

          if (isNearBottom) {
            onScrollToBottom();
          }
        },
        100,
        { leading: true }
      ),
    [onScrollToBottom]
  );
  useEffect(() => () => scrollCallback.cancel(), [scrollCallback]);
  useEffect(() => {
    document.addEventListener('scroll', scrollCallback);
    return () => {
      document.removeEventListener('scroll', scrollCallback);
    };
  }, [scrollCallback]);
};
export default useInfiniteScroll;
